// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"EditField_loadingOverlay__3mA0h","spin":"EditField_spin__0BTZd"};